module.exports = __webpack_public_path__ + "static/media/video.16c250a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/ServiceIcons/video.svg
// module id = 1212
// module chunks = 0